import React, { useCallback, useEffect, useState } from "react"
import { NavLink, useParams } from "react-router-dom"
import { MdDownload, MdOutlineAssessment } from "react-icons/md"
import { toast } from "react-toastify"
import api from "../../services/api"
import BulkActionHistory from "../ManagementLog/BulkActionHistory"
import { openLinkExternal } from "../../utils/utils"

const ExportLog = () => {
    const [reports, setReports] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { account_id } = useParams()

    const getAllReports = useCallback(async ({ silent = false } = {}) => {
        try {
            if (!silent) setIsLoading(true)
            const response = await api.get("/reports")
            setReports(response.data?.data || [])
        } catch (err) {
            if (!silent) toast.error(err?.response?.data?.message || "Não foi possível carregar as exportações.")
        } finally {
            if (!silent) setIsLoading(false)
        }
    }, [])

    useEffect(() => {
        getAllReports()
    }, [getAllReports])

    const data = reports.map(report => ({
        ...report,
        action_label: "Exportação de dados",
        action_summary: report.name || `Relatório de ${report.type || "dados"}`,
        status: report.status || (report.url ? "completed" : "processing"),
        count: 0,
        count_updated: 0,
    }))

    return (
        <BulkActionHistory
            data={data}
            title="Histórico de Exportações"
            description="Acompanhe a geração dos arquivos, consulte falhas e faça o download quando estiverem prontos."
            isLoading={isLoading}
            onRefresh={getAllReports}
            progressLabel="Processamento"
            showProgress={() => false}
            getActionIcon={() => MdOutlineAssessment}
            getDetails={item => [
                { label: "Tipo do relatório", value: item.type || "-" },
                { label: "Arquivo", value: item.name || "Ainda não gerado" },
                { label: "Início", value: item.started_at || item.created_at || "-" },
                { label: "Conclusão", value: item.finished_at || "Em aberto" },
                { label: "Última atualização", value: item.updated_at || "-" },
                { label: "Identificador", value: item._id, executionId: true },
            ]}
            getActions={item => item.url ? [{
                label: "Baixar arquivo",
                icon: MdDownload,
                onClick: current => openLinkExternal(current.url),
            }] : []}
            headerAction={<NavLink to={`/${account_id}/reports`}>Nova exportação</NavLink>}
        />
    )
}

export default ExportLog
